<template>
  <crud-button
    large
    color="green"
    @clicked="doExport()"
    icon="fa-file-export"
    :tooltip="$t('global.crud.buttons.export')"
  />
</template>

<script>
import localhttp from "../js/https-commons";
import CrudButton from "@/components/Button.vue";
import XLSX from "xlsx";

export default {
  components: {
    CrudButton
  },
  props: {
    url: {
      type: String
    },
    filter: {
      type: Object
    },
    itemsPerPage: {
      type: Number,
      default: 1000
    },
    item: {
      type: Object
    },
    processFilter: { type: Function },
    filterExport: { type: Function }
  },
  methods: {
    doExport() {
      if (this.item != undefined) {
        this.processFilter(this.item);
      } else if (this.processFilter != undefined) {
        this.processFilter(this.filter);
      }

      //page 1. Limit export registers
      this.filter.page = 1;
      this.filter.itemsPerPage = this.itemsPerPage;

      localhttp
        .post(this.url + "/export", this.filter)
        .then(response => {
          if (response.data != null && response.data.length > 0) {
            var jsonData = response.data;
            //filter data result
            this.globalFilterExport(jsonData);
            if (this.filterExport != undefined) {
              this.filterExport(jsonData);
            }

            //convert to excel
            var ws = XLSX.utils.json_to_sheet(response.data);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(
              wb,
              ws,
              this.url.substring(1).replaceAll("/", "_")
            );

            XLSX.writeFile(
              wb,
              this.url.substring(1).replaceAll("/", "_") + ".xlsx"
            );
          }
        })
        .catch(e => {
          console.log(e);
          this.$showError();
        });
    },
    globalFilterExport(jsonData) {
      jsonData.forEach(function(v) {
        //timestamp of deletion date TO true/false
        if (v.deletionDate !== undefined) {
          if (v.deletionDate !== null) {
            v.deletionDate = true;
          } else {
            v.deletionDate = false;
          }
        }
      });
    }
  }
};
</script>
